style {
    .ui-text {
        font-family: var(--text-font);
    }
}

ui-element.ui-text tag="p"||input.tag ...input class=input.class
    <${input.renderBody}/>